/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAgreementContactNote
 */
export interface ServiceAgreementContactNote {
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementContactNote
     */
    contactNoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementContactNote
     */
    contactNoteUid?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementContactNote
     */
    startDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementContactNote
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementContactNote
     */
    contactType?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementContactNote
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceAgreementContactNote
     */
    qualifiedClientContact?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementContactNote
     */
    createdAt?: string;
}

/**
 * Check if a given object implements the ServiceAgreementContactNote interface.
 */
export function instanceOfServiceAgreementContactNote(value: object): value is ServiceAgreementContactNote {
    return true;
}

export function ServiceAgreementContactNoteFromJSON(json: any): ServiceAgreementContactNote {
    return ServiceAgreementContactNoteFromJSONTyped(json, false);
}

export function ServiceAgreementContactNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementContactNote {
    if (json == null) {
        return json;
    }
    return {
        
        'contactNoteId': json['contactNoteId'] == null ? undefined : json['contactNoteId'],
        'contactNoteUid': json['contactNoteUid'] == null ? undefined : json['contactNoteUid'],
        'startDateTime': json['startDateTime'] == null ? undefined : json['startDateTime'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'contactType': json['contactType'] == null ? undefined : json['contactType'],
        'status': json['status'] == null ? undefined : json['status'],
        'qualifiedClientContact': json['qualifiedClientContact'] == null ? undefined : json['qualifiedClientContact'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function ServiceAgreementContactNoteToJSON(json: any): ServiceAgreementContactNote {
    return ServiceAgreementContactNoteToJSONTyped(json, false);
}

export function ServiceAgreementContactNoteToJSONTyped(value?: ServiceAgreementContactNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactNoteId': value['contactNoteId'],
        'contactNoteUid': value['contactNoteUid'],
        'startDateTime': value['startDateTime'],
        'subject': value['subject'],
        'contactType': value['contactType'],
        'status': value['status'],
        'qualifiedClientContact': value['qualifiedClientContact'],
        'createdAt': value['createdAt'],
    };
}

